// ============================================================
// StatusBadge — Colored Status Indicator
// ============================================================

import { Chip } from '@mui/material';
import { tokens } from '@/theme/tokens';

const STATUS_STYLES = {
  active: { bg: `${tokens.colors.success.main}15`, color: tokens.colors.success.main },
  inactive: { bg: tokens.colors.grey[100], color: tokens.colors.text.muted },
  pending: { bg: `${tokens.colors.warning.main}15`, color: tokens.colors.warning.main },
  approved: { bg: `${tokens.colors.success.main}15`, color: tokens.colors.success.main },
  rejected: { bg: `${tokens.colors.error.main}15`, color: tokens.colors.error.main },
  paid: { bg: `${tokens.colors.success.main}15`, color: tokens.colors.success.main },
  unpaid: { bg: `${tokens.colors.error.main}15`, color: tokens.colors.error.main },
  partial: { bg: `${tokens.colors.warning.main}15`, color: tokens.colors.warning.main },
  overdue: { bg: `${tokens.colors.error.main}15`, color: tokens.colors.error.main },
  present: { bg: `${tokens.colors.success.main}15`, color: tokens.colors.success.main },
  absent: { bg: `${tokens.colors.error.main}15`, color: tokens.colors.error.main },
  late: { bg: `${tokens.colors.warning.main}15`, color: tokens.colors.warning.main },
  on_leave: { bg: `${tokens.colors.warning.main}15`, color: tokens.colors.warning.main },
  suspended: { bg: `${tokens.colors.error.main}15`, color: tokens.colors.error.main },
  resigned: { bg: tokens.colors.grey[100], color: tokens.colors.text.muted },
  terminated: { bg: `${tokens.colors.error.main}15`, color: tokens.colors.error.main },
};

export function StatusBadge({ status, label, size = 'small' }) {
  const style = STATUS_STYLES[status?.toLowerCase()] || STATUS_STYLES.inactive;

  return (
    <Chip
      label={label || status}
      size={size}
      sx={{
        backgroundColor: style.bg,
        color: style.color,
        fontWeight: tokens.typography.fontWeights.semiBold,
        fontSize: tokens.typography.sizes.xs,
        textTransform: 'capitalize',
        border: 'none',
      }}
    />
  );
}
